/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import styles, {getClasses} from '../editors/editorStyles';
import {DLSTheme} from '../types/types';
import {StylesDefinition, useExtendStyles} from './useExtendStyles';

const editorStyleOverrides = (theme: DLSTheme) => ({
  formPaper : {
    borderRadius                   : '10px',
    height                         : 'calc(100vh - 94px)',
    width                          : '75%',
    [theme.breakpoints.down('sm')] : {
      maxWidth : '100%'
    }
  },
  formDialogContent : {
    [theme.breakpoints.down('sm')] : {
      paddingTop : '0px'
    }
  }
});

/**
 * Helper to combine and return any needed editor classes shared among components.
 *
 * ```typescript
 *
 *  import {useEditorStyles} from '@ion/dls/src/hooks/useEditorStyles';
 *
 *  const {classes, paperClasses} = useEditorStyles();
 *
 * ```
 */
export const useEditorStyles = (props?: GenericObject, overrideStyles?: StylesDefinition) => {
  const classes = useExtendStyles(styles, overrideStyles || editorStyleOverrides)(props);

  return {
    classes,
    paperClasses : getClasses(classes)
  };
};
